import datasetFactory from '../../factories/sunburst-dataset';
import MultilevelPie from '../multilevelpie';
import { pluckNumber, extend2 } from '@fusioncharts/core/src/lib';

const DEFAULT_PALETTE_COLOR = [
    '1E77B4',
    'FF7F0E',
    '2BA02C',
    'D62728',
    '9466BD',
    '8C564B',
    'E376C2',
    '7F7F7F',
    'BCBD22',
    '17BECF'
  ],
  DEFAULT_BG_COLOR = 'FFFFFF,FFFFFF';

class Sunburst extends MultilevelPie {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'Sunburst';
  }

  constructor () {
    super();
    this.defaultPaletteOptions = {
      // Store colors now
      paletteColors:
        [
          DEFAULT_PALETTE_COLOR,
          DEFAULT_PALETTE_COLOR,
          DEFAULT_PALETTE_COLOR,
          DEFAULT_PALETTE_COLOR,
          DEFAULT_PALETTE_COLOR
        ],
      bgColor: [DEFAULT_BG_COLOR, DEFAULT_BG_COLOR, DEFAULT_BG_COLOR, DEFAULT_BG_COLOR, DEFAULT_BG_COLOR]
    };
    this.registerFactory('dataset', datasetFactory, ['canvas']);
  }

  __setDefaultConfig () {
    super.__setDefaultConfig();
    this.config.allowdrilltonode = 1;
    this.config.showvaluesintooltip = 1;
  }

  configureAttributes (dataSource) {
    super.configureAttributes(dataSource);
    let chart = this;
    chart.config.allowdrilltonode = pluckNumber(dataSource.chart.allowdrilltonode, 1);

    if (chart.config.allowdrilltonode) {
      chart.addToEnv('linkClickFN', function () { return null; });
    }
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'Sunburst';
  }
  /**
   * function to check if the chart specific data is proper is not
   * this fn is define for specific chart types
   * @return {boolean} if JSON data is valid or not
   */
  _checkInvalidSpecificData () {
    const parsedDS = this.parseAndSanitizeData();
    let i = 0;

    if (!parsedDS || !Array.isArray(parsedDS) || parsedDS.length === 0) {
      return true;
    }

    for (; i < parsedDS.length; i++) {
      if (parsedDS[i].category && parsedDS[i].category.length === 0 && !parsedDS[i].value) {
        return true;
      }
    }
  }

  parseAndSanitizeData () {
    let categories = [],
      flatInput = [],
      tempMap = {},
      chart = this,
      dataSource = extend2({}, chart.getFromEnv('dataSource'));

    if (dataSource && dataSource.data && Array.isArray(dataSource.data)) {
      flatInput = dataSource.data.map(item => {
        tempMap[item.id] = item;
        !item.parent && (item.isRootNode = true);
        !item.categories && (item.category = []);
        return item;
      }).filter(item => {
        if (item.id && (!item.value || !isNaN(+item.value))) {
          if (!item.parent || (item.parent && tempMap[item.parent])) {
            return true;
          }
        }
        delete tempMap[item.id];
        return false;
      });

      for (let key in tempMap) {
        if (tempMap.hasOwnProperty(key)) {
          let item = tempMap[key];
          if (item.parent) {
            tempMap[item.parent].category.push(item);
          }
          if (item.isRootNode) {
            categories.push(item);
          }
        }
      }

      chart.addToEnv('parsedDataSource', categories);
    }
    return flatInput;
  }
}
export default Sunburst;
